export default "__VITE_ASSET__3716d79c__"